export default __webpack_public_path__ + "static/ShamelFamily-SansBold-9b4a39676a42dddca7285d7bf97e322b.ttf";